// extracted by mini-css-extract-plugin
export default {"footer-wrapper":"Footer_footer-wrapper__LSGsc","oper-box":"Footer_oper-box__ygS3e"};